import React, { FC, HTMLAttributes, useMemo } from 'react';
import classNames from 'classnames';
import styles from './TextArea.module.scss';
import { FaIcon } from 'components/ui';
import { Error } from 'components';

export interface ITextArea extends HTMLAttributes<HTMLDivElement> {
  value: string;
  label: string;
  name: string;
  error?: string;
  hasError: boolean;
  onChange?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  required?: boolean;
  disabled?: boolean;
}

const TextArea: FC<ITextArea> = (props) => {
  const {
    label,
    value,
    name,
    error,
    disabled,
    className,
    hasError,
    onChange,
    onFocus,
    onBlur,
    required,
    ...otherProps
  } = props;

  const labelContent = useMemo(
    () =>
      required ? (
        <span className={styles.labelContent}>
          <FaIcon className='mr-1' icon='lock-alt' />
          {`${label} *`}
        </span>
      ) : (
        label
      ),
    [label, required]
  );

  const rootClassName = classNames(styles.root, className, {
    [styles.disabled]: disabled,
    [styles.error]: error,
  });

  return (
    <div className={rootClassName} {...otherProps}>
      <label className={styles.label}>{labelContent}</label>
      <textarea
        className={styles.textarea}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        required={required}
      />
      <Error className={styles.error} isError={!!error}>
        {error}
      </Error>
    </div>
  );
};

export default TextArea;
